import React, { useState, useEffect } from 'react';

import { Box, Button, Divider, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import OrderBookAddModalContainer from '../../../containers/chancemng/obtainorder/OrderBookAddModalContainer';
import OrderBookEditModalContainer from '../../../containers/chancemng/obtainorder/OrderBookEditModalContainer';
import OrderBookHistoryListContainer from '../../../containers/chancemng/obtainorder/OrderBookHistoryListContainer';

import {
  chanceEstimateActive,
  chanceOrderCount,
} from '../../../modules/chanceModule/chance';
import _ from 'lodash';

const ObtainorderTemplate = ({ setActiveStep, setSelectedTab }) => {
  const dispatch = useDispatch();
  const { chance, activeEstimate, orderCount } = useSelector(
    ({ chanceModule }) => ({
      chance: chanceModule.chance.chance,
      activeEstimate: chanceModule.chance.activeEstimate,
      orderCount: chanceModule.chance.orderCount,
    }),
  );

  const [type, setType] = useState('add');
  const [open, setOpen] = useState(false);
  const [roUuid, setRoUuid] = useState(null);
  const [isActive, setIsActive] = useState(true);

  const handleClose = () => {
    setRoUuid(null);
    setType('add');
    setOpen(false);
  };

  const editFunction = (param) => {
    setType('edit');
    setRoUuid(param.id);
    setOpen(true);
  };

  const handleAddOrder = () => {
    setType('add');
    setOpen(true);
  };

  useEffect(() => {
    if (chance) {
      dispatch(chanceOrderCount(chance.prjUuid));
      dispatch(chanceEstimateActive(chance.prjUuid));
    }
  }, [chance]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <OrderBookHistoryListContainer
        editFunction={editFunction}
        setIsActive={setIsActive}
      />
      <Divider sx={{ my: 1 }} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {_.isEmpty(activeEstimate) ? (
          <Box>
            <Typography variant="subtitle2" component="div" color="error">
              활성화된 견적서가 없습니다. 신규 수주품의서를 작성하려면 견적서를
              작성하세요
            </Typography>
          </Box>
        ) : isActive ? (
          <Box>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleAddOrder}
              sx={{ mr: 1 }}
            >
              수주품의서 작성
            </Button>
          </Box>
        ) : (
          <Box>
            <Typography variant="subtitle2" component="div" color="error">
              결재가 완료 또는 진행중인 수주품의서가 있어 신규 수주품의서를
              작성할 수 없습니다.
            </Typography>
          </Box>
        )}
      </Box>
      {type === 'add' ? (
        <OrderBookAddModalContainer
          type={type}
          open={open}
          handleClose={handleClose}
        />
      ) : (
        <OrderBookEditModalContainer
          type={type}
          open={open}
          handleClose={handleClose}
          roUuid={roUuid}
        />
      )}
    </Box>
  );
};

export default ObtainorderTemplate;
